const $ = require('jquery');
const gtmTracking = require('../components/tracking/tracking');
const refinements = require('../utils/refinements');
const WishListHeartIcon = require('./WishListHeartIcon');
const variationValidation = require('./product/validVariation');

let wishlistIcon;
const wishlistIconsOnCartPage = [];

/**
 * @typedef {{
 *  preventDefault: Function,
 *  stopPropagation: Function,
 *  currentTarget: Function
 * }} event
 */

/**
 * Hide notification after adding a product to the wishlist
 */
const hideNotification = function () {
    const $notification = $('.product-wishlist-notification');
    $notification.fadeOut(300);
};

/**
 * Show notification after adding a product to the wishlist
 */
const showNotification = function () {
    const $notification = $('.product-wishlist-notification');

    if (!$notification.length) {
        return;
    }

    $notification.off('click').on('click', function (e) {
        e.stopPropagation();
    });

    $notification
        .find('.icon-close')
        .off('click')
        .on('click', function (e) {
            e.preventDefault();
            hideNotification();
        });

    // Show the notification
    $notification
        .css('display', 'flex')
        .hide()
        .fadeIn(400, function () {
            // Scroll to position
            const elBottom = $notification.offset().top + $notification.outerHeight(true);
            const currentBottom = window.scrollY + window.innerHeight;
            if (elBottom >= currentBottom) {
                $('html, body').animate(
                    {
                        scrollTop: window.scrollY + (elBottom - currentBottom) + 10
                    },
                    200
                );
            }
        });
};

/**
 * Finds current wishlist icon
 *
 * @param {string} pid Product ID
 * @returns {Object} - Wishlist icon object
 */
const findCurrentWishListIcon = function (pid) {
    return wishlistIconsOnCartPage.find(product => product.id === pid)?.icon;
};

/**
 * @namespace document
 * @description Handler to handle the add to wishlist event
 * @param {event} event - click evt
 */
const clickFavoritesEventHandler = function (event) {
    const $link = $(event.currentTarget);
    // is main PDP product, not other product from PDP page from recommendations
    const isMainPDPProduct = $link.hasClass('js-pdp-heart-icon');
    const isCartProduct = $link.hasClass('js-cart-heart-icon');

    event.preventDefault();
    event.stopPropagation();

    if (isMainPDPProduct && wishlistIcon && !wishlistIcon.isEnabledAddingToWishlist) {
        variationValidation.validate(true);
    }

    if ($link.hasClass('disabled')) {
        return;
    }

    const $linkIcon = $link.find('i');
    const $miniWishlistContainer = $('li.nav-item-wishlist');
    const $miniWishlist = $('.mini-whishlist-total a');
    let $mobileQty;
    const url = $link.data('href');
    const pid = $link.data('pid');
    const source = $link.data('source');
    let qty = 0;
    const ACTIVE_CLASS = 'icon-wishlist-active';
    const INACTIVE_CLASS = 'icon-wishlist';
    let wishlistLinkPID;
    const triggeredFromQuickShop = $link.closest('form').hasClass('quickShopForm');

    const isProductInWishList = isCartProduct
        ? findCurrentWishListIcon(pid)?.isInWishlist(pid)
        : wishlistIcon?.isInWishlist(pid);

    const selectedRefinements = refinements.getSelectedRefinements();

    const data = {
        pid
    };

    if (selectedRefinements) {
        const sizeNameCountry = `sizeName_${window.CURRENT_COUNTRY}`; // for constructor sizename
        if (selectedRefinements[sizeNameCountry]) {
            selectedRefinements.sizeName = selectedRefinements[sizeNameCountry];
        }

        if (selectedRefinements.sizeName?.length === 1 && selectedRefinements.width?.length === 1) {
            [data.selectedSize] = selectedRefinements.sizeName;
            [data.selectedWidth] = selectedRefinements.width;
        }
    }

    if (url && pid) {
        $.ajax({
            url,
            data,
            type: 'POST'
        }).done(function (res) {
            $miniWishlistContainer.html(res);
            if ($linkIcon.hasClass(ACTIVE_CLASS)) {
                let newAddLink = $miniWishlist.data('favaurl').replace('__PID__', $link.data('pid'));
                if (source === 'plp') {
                    newAddLink += '&source=plp';
                }

                // change state of every whishlist icon with same PID on that page
                $('.product-wishlist-link').each((_index, wishlistLink) => {
                    wishlistLinkPID = $(wishlistLink).data('pid');
                    if (wishlistLinkPID === pid) {
                        $(wishlistLink).data('href', newAddLink).prop('title', $miniWishlist.data('favatxt'));
                        $(wishlistLink).find('i').addClass(INACTIVE_CLASS).removeClass(ACTIVE_CLASS);
                    }
                });
            } else {
                let newRemoveLink = $miniWishlist.data('favrurl').replace('__PID__', $link.data('pid'));
                if (source === 'plp') {
                    newRemoveLink += '&source=plp';
                }

                // change state of every whishlist icon with same PID on that page
                $('.product-wishlist-link').each((_index, wishlistLink) => {
                    wishlistLinkPID = $(wishlistLink).data('pid');
                    if (wishlistLinkPID === pid) {
                        $(wishlistLink).data('href', newRemoveLink).prop('title', $miniWishlist.data('favatxt'));
                        $(wishlistLink).find('i').addClass(ACTIVE_CLASS).removeClass(INACTIVE_CLASS);
                        if (window.dataLayer && window.dataLayerCLP && window.dataLayerCLP.length) {
                            window.dataLayerCLP[0].ecommerce.items[0].index = _index;
                            window.dataLayer.push(window.dataLayerCLP[0]);
                            window.dataLayerCLP = [];
                        }
                    }
                });

                if (triggeredFromQuickShop) {
                    gtmTracking.trackQuickShopAddToWishlist(pid);
                }
            }
            // change quantity for mobile header
            qty = $('.mini-whishlist-total .mini-wishlist-quantity').html();
            if (qty) {
                $mobileQty = $('.header-mobile-wishlist .qty');
                if ($mobileQty.length === 0) {
                    $('.header-mobile-wishlist').append('<span class="qty"></span>');
                }
                $('.header-mobile-wishlist .qty').html(qty);
            } else if ($('.header-mobile-wishlist .qty')) {
                $('.header-mobile-wishlist .qty').remove();
            }
            // close quickShop flyIn
            if (triggeredFromQuickShop) {
                $('.ocd-close').trigger('click');
            }

            if (isMainPDPProduct && wishlistIcon) {
                wishlistIcon.updateWishlistButton(!isProductInWishList, String(pid));
            }

            if (isCartProduct) {
                findCurrentWishListIcon(pid)?.isInWishlist(pid);
                const {icon: updatedWishListIcon} = wishlistIconsOnCartPage.find(
                    wishlistIconObject => wishlistIconObject.id === pid
                );

                if (updatedWishListIcon) {
                    updatedWishListIcon.updateWishlistButton(!isProductInWishList, String(pid));
                }
            }

            if ($linkIcon.hasClass(ACTIVE_CLASS)) {
                showNotification();
            } else {
                hideNotification();
            }
        });
    }
};

/**
 * Starts, when you click on the button, but not the heart
 *
 * @param {event} event - click evt
 */
const clickFavoritesAroundEventHandler = function (event) {
    const $this = $(event.currentTarget);
    if ($this.hasClass('disabled')) {
        event.preventDefault();
    } else {
        $this.find('.js-favorite').trigger('click');
    }
};

/**
 * restore the link on PDP, if removing an item from mini wishlist
 *
 * @param {event} event - click evt
 */
const clickMiniRemoveHandler = function (event) {
    const $this = $(event.currentTarget);
    const pid = $this.data('pid');
    const $productLink = $('.product-content-bottom .product-wishlist .js-favorite'); // more specific so we don't get the icon from sticky add to cart

    event.preventDefault();
    if (pid && $productLink && $productLink.data('pid') === pid) {
        $productLink.trigger('click');
    }
};

/**
 * When remove item from miniwishlist, remove it from lists like in PLP and cart
 *
 * @param {event} event - click evt
 */
const clickMiniRemoveHandlerList = function (event) {
    const $this = $(event.currentTarget);
    const pid = $this.data('pid');

    if (pid) {
        $('.product-wishlist-link').each((_index, el) => {
            if ($(el).data('pid') === pid) {
                $(el).trigger('click');
            }
        });
    }
};

/**
 * initially starts when loading the page
 */
function initializeEvents() {
    $('.product-wishlist, .product-tile .product-wishlist')
        .off('click', '.js-favorite')
        .on('click', '.js-favorite', clickFavoritesEventHandler);

    $('.pt_product-details')
        .off('click', '.mini-cart-product-list .remove-product')
        .on('click', '.mini-cart-product-list .remove-product', clickMiniRemoveHandler);
    $('.pt_product-search-result').off('click', '.mini-cart-product-list .remove-product');
    $('.pt_product-search-result').on('click', '.mini-cart-product-list .remove-product', clickMiniRemoveHandlerList);
}

/**
 * initiallize events in quick shop flyIn
 */
function initializeEventsQuickShop() {
    wishlistIcon = new WishListHeartIcon('div.wishlist-icon-container');
    // removes old listener
    $(
        '.ocd-flyin.quick-shop .ocd-content .product-wishlist, .product-tile .product-wishlist, .quickshop-dialog .product-wishlist'
    ).off('click', '.js-favorite');
    $('.ocd-flyin.quick-shop .ocd-content, .quickshop-dialog .product-wishlist').off('click', '.product-wishlist');
    $('.ocd-flyin.quick-shop .ocd-content, .quickshop-dialog .product-wishlist').off(
        'click',
        '.mini-cart-product-list .remove-product'
    );
    // adds new listener
    $(
        '.ocd-flyin.quick-shop .ocd-content .product-wishlist, .product-tile .product-wishlist, .quickshop-dialog .product-wishlist'
    )
        .not('.disabled')
        .on('click', '.js-favorite', clickFavoritesEventHandler);
    $('.ocd-flyin.quick-shop .ocd-content, .quickshop-dialog .product-wishlist').on(
        'click',
        '.product-wishlist',
        clickFavoritesAroundEventHandler
    );
    // listener for the mini wishlist
    $('.ocd-flyin.quick-shop .ocd-content, .quickshop-dialog .product-wishlist').on(
        'click',
        '.mini-cart-product-list .remove-product',
        clickMiniRemoveHandler
    );
}

/**
 * Initilize wishlist icons on the cart page
 */
function initWishlistIconsOnCart() {
    const productsInCart = $('div.js-wishlist-cart')?.data('cartProductIds')?.toString().split(',') || [];

    productsInCart.forEach(product => {
        wishlistIconsOnCartPage.push({
            id: Number(product),
            icon: new WishListHeartIcon(`div.wishlist-icon-container-${product}`)
        });
    });
}

/**
 * Initilize event for add/remove product to wishlist from cart
 */
function initializeEventsCart() {
    initWishlistIconsOnCart();
    // removes old listener
    $('.pt_cart .cart-table .product-wishlist, .product-tile .product-wishlist').off('click', '.js-favorite');
    $('.pt_cart .cart-table').off('click', '.product-wishlist');
    $('.pt_cart').off('click', '.mini-cart-product-list .remove-product');
    // adds new listener
    $('.pt_cart .cart-table .product-wishlist, .product-tile .product-wishlist')
        .not('.disabled')
        .on('click', '.js-favorite', clickFavoritesEventHandler);
    $('.pt_cart .cart-table').on('click', '.product-wishlist', clickFavoritesAroundEventHandler);
    // listener for the mini wishlist
    $('.pt_cart').on('click', '.mini-cart-product-list .remove-product', clickMiniRemoveHandlerList);
}

/**
 * Fill wishlist heart icon in search/recommendations by checking is item in wishlist from data in miniwishlist
 */
function initProductTilesWishlist() {
    if (!SitePreferences.ENABLE_WISHLIST_CLP_AND_REC) {
        return;
    }
    const $miniWishlist = $('li.nav-item-wishlist a.mini-wishlist-link');

    const productsInWishlist = $miniWishlist.data('favpids')?.toString().split('|');
    const activeClass = 'icon-wishlist-active';
    const inactiveClass = 'icon-wishlist';

    if (productsInWishlist && productsInWishlist.length > 0) {
        $('.product-tile:not(.js-wishlist-processed)').each((_index, tile) => {
            const tileProductId = $(tile).data('itemid');
            const tileVariantIds = $(tile).data('variantsids')?.toString().split('|');
            let isInWishlist = false;

            if (productsInWishlist.includes(tileProductId?.toString())) {
                isInWishlist = true;
            } else if (tileVariantIds) {
                isInWishlist = tileVariantIds.some(variationId => {
                    return variationId && productsInWishlist.includes(variationId.toString());
                });
            }

            if (isInWishlist) {
                const $tileWishlistLink = $(tile).find('.product-wishlist-link');
                const $tileWishlistIcon = $tileWishlistLink.find('i');

                const newRemoveLink = `${$miniWishlist
                    .data('favrurl')
                    .replace('__PID__', $tileWishlistLink.data('pid'))}&source=plp`;

                $tileWishlistLink.data('href', newRemoveLink).prop('title', $miniWishlist.data('favrtxt'));
                $tileWishlistIcon.addClass(activeClass).removeClass(inactiveClass);
            }
            $(tile).addClass('js-wishlist-processed');
        });
    }
}

module.exports = {
    /**
     * PDP initialization
     *
     * @param {boolean} isInitializedFromPDP - determines whether the wishlist is initialized from PDP or not
     */
    init(isInitializedFromPDP) {
        initProductTilesWishlist();
        initializeEvents();
        if (!isInitializedFromPDP) {
            return;
        }

        wishlistIcon = new WishListHeartIcon('div.wishlist-icon-container:visible');
    },
    initProductTilesWishlist,
    initWishlistQuickShop: initializeEventsQuickShop,
    initWishlistCart: initializeEventsCart
};
